/**
 * Renders button to proceed to next question.
 */
import classnames from 'classnames';
import React, { PropTypes } from 'react';

function ButtonNext({ actionButton, disabled, nextStep }) {
  return (
    <span>
      {!disabled &&
        <button
          className={classnames({
            'assessment--next': true,
          })}
          disabled={disabled}
          onClick={nextStep}
        >
          {actionButton}
        </button>
      }
    </span>
  );
}

ButtonNext.propTypes = {
  actionButton: PropTypes.string,
  disabled: PropTypes.bool,
  nextStep: PropTypes.func,
};

ButtonNext.defaultProps = {
  actionButton: 'Next',
  disabled: false,
};

export default ButtonNext;



// WEBPACK FOOTER //
// js/src/assessment/ButtonNext.js